<template>
    <v-list dense>
        <v-list-item @click.stop="logOut">
            <v-list-item-action>
                <v-icon>fa-sign-out-alt</v-icon>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>
</template>

<script>
    import authentication from '@/authentication'

    export default {
        name: "TheRighthandSidebarMenu",
        data: () => ({
            systemName: process.env.VUE_APP_SYSTEM_NAME,
            ecsLogo: 'https://cdn.theecsgroup.com/images/ecs-group-logo.png',
            connectLogo: 'https://cdn.theecsgroup.com/images/connect-logo.png',
            connectLink: 'https://connect.theecsgroup.com'
        }),
        methods: {
            logOut() {
                authentication.signOut();
            },
        }

    }
</script>

<style scoped>

</style>
